import { DashboardCardConfig } from './DashboardCardConfig';

export type TabId = string;


export const DEFAULT_TAB_ID = 'default-my-dashboard';
export const DEFAULT_TAB_LABEL = 'My Dashboard';
export const MAX_TABS = 8;
export const MAX_CARDS_PER_TAB = 12;

export const TAB_PALETTE_KEYS = [
    'blue',
    'red',
    'yellow',
    'green',
    'purple',
] as const;

export type TabColorKey = (typeof TAB_PALETTE_KEYS)[number];
export const DEFAULT_TAB_COLOR_KEY: TabColorKey = 'blue';

export const isTabColorKey = (value: string | undefined): value is TabColorKey =>
    TAB_PALETTE_KEYS.includes(value as TabColorKey);

export interface DashboardTabConfig {
    id: TabId;
    label: string;
    isDefault: boolean;
    cards: DashboardCardConfig[];
    colorKey: TabColorKey;
}

export interface DashboardTabState {
    tabs: DashboardTabConfig[];
    activeTabId: TabId;
    lastUpdated: string;
}
